module.exports = __webpack_public_path__ + "png/roulette-timer-big.png?48b7ac93823d0ad1701177304c724a81";